import { Fragment } from 'react';
import { useFormikContext } from 'formik';

import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';
import { selectActiveToken } from 'redux/slices/tokens';

import TokenAmount from 'components/wallet/token-amount';
import Amount from '../amount';

import { FormValues } from 'types';

import {
  StyledSummary,
  StyledSummaryLabel,
  StyledSummaryValue,
  StyledSummaryList,
  StyledSummaryItem,
  StyledTitle,
  StyledInfo,
  StyledInputLabel,
  StyledInputValue,
  StyledInputWrapper
} from '../../send-view.style';

const ReviewView = ({ estimatedFeesInNear, estimatedTotalInNear }) => {
  const accountId = useAppSelector(selectAccountId);
  const activeToken = useAppSelector(selectActiveToken);
  const formik = useFormikContext<FormValues>();

  return (
    <Fragment>
      <StyledTitle>You are sending</StyledTitle>
      <StyledInfo>
        <TokenAmount amount={formik.values.amount} />
        <span>{formik.values.token}</span>
      </StyledInfo>
      <StyledInputWrapper mb="20px">
        <StyledInputLabel>Send to</StyledInputLabel>
        <StyledInputValue
          fontSize="xs"
          fontWeight="semiBold"
          color="input.text"
        >
          {formik.values.receiverId}
        </StyledInputValue>
      </StyledInputWrapper>
      <StyledInputWrapper mb="20px">
        <StyledInputLabel>From</StyledInputLabel>
        <StyledInputValue fontSize="xs" fontWeight="semiBold">
          {accountId}
        </StyledInputValue>
      </StyledInputWrapper>
      <StyledSummary>
        <StyledSummaryItem>
          <StyledSummaryLabel>Asset</StyledSummaryLabel>
          <StyledSummaryValue>{formik.values.token}</StyledSummaryValue>
        </StyledSummaryItem>
        <StyledSummaryList>
          <Amount
            title="Estimated fees"
            amount={estimatedFeesInNear}
            symbol="NEAR"
          />
          {activeToken.onChainFTMetadata?.symbol === 'NEAR' ? (
            <Amount
              title="Estimated total"
              amount={estimatedTotalInNear}
              symbol="NEAR"
            />
          ) : (
            <Amount
              title="Amount"
              amount={formik.values.amount}
              symbol={activeToken.onChainFTMetadata?.symbol}
              decimals={activeToken.onChainFTMetadata?.decimals}
            />
          )}
        </StyledSummaryList>
      </StyledSummary>
    </Fragment>
  );
};

export default ReviewView;
